import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  LinearProgress,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
} from '@material-ui/core';

import i18n from '../../i18n';

class InProgressListItem extends Component {
  render() {
    const {
      completed,
      primaryText,
      secondaryText,
      secondaryAction,
    } = this.props;
    return (
      <ListItem>
        {completed ? 
          (
            <Typography className='greenText'>
              {i18n.t('done').toUpperCase()}
            </Typography>)
          : (
            <Box style={{width: '100%', paddingTop: '4%', paddingRight: '4%', paddingLeft: '4%' }}>
              <LinearProgress className='ssensePrimary' />
            </Box>
          )
        }
        <ListItemText
          primary={primaryText}
          secondary={secondaryText}
        />
        <ListItemSecondaryAction>
          {secondaryAction}
        </ListItemSecondaryAction>
      </ListItem>
    )
  }
}

InProgressListItem.defaultProps = {
  secondaryText: null,
  completed: false,
  secondaryAction: null,
}

InProgressListItem.propTypes = {
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  completed: PropTypes.bool,
  secondaryAction: PropTypes.node,
}

export default InProgressListItem;
